<template>
  <section class="section has-text-centered">
    <div class="container">
      <p class="title is-size-4">Targets</p>
      <p>Overall target achievement by type of target</p>
      <br />
      <div class="columns is-mobile is-centered">
        <div class="column is-2-desktop is-4-mobile">
          <HitVsMissTarget
            :targetHistories="targetHistories"
            targetType="recordings"
          />
        </div>
        <div class="column is-2-desktop is-4-mobile">
          <HitVsMissTarget
            :targetHistories="targetHistories"
            targetType="seconds"
          />
        </div>
        <div class="column is-2-desktop is-4-mobile">
          <HitVsMissTarget
            :targetHistories="targetHistories"
            targetType="spellings"
          />
        </div>
      </div>
      <br />
      <p>
        Comparison of your recent daily activity and targets by target type
      </p>
      <div class="columns is-centered is-multiline">
        <div class="column is-6">
          <TargetsVsRealized
            :targetHistories="targetHistories"
            targetType="recordings"
          />
        </div>
        <div class="column is-6">
          <TargetsVsRealized
            :targetHistories="targetHistories"
            targetType="seconds"
          />
        </div>
        <div class="column is-6">
          <TargetsVsRealized
            :targetHistories="targetHistories"
            targetType="spellings"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HitVsMissTarget from "./HitVsMissTarget";
import TargetsVsRealized from "./TargetsVsRealized";
export default {
  components: { HitVsMissTarget, TargetsVsRealized },
  props: ["targetHistories"]
};
</script>

<style lang="scss" scoped></style>
